
import { defineComponent, ref, onMounted, computed } from "vue";

import Leaderboard from "@/components/Leaderboard.vue";

export default defineComponent({
  name: "Leaderboard",
  components: {
    "leaderboard-component": Leaderboard,
  },
  setup() {
    onMounted(async () => {});

    return {};
  },
});
